var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledstar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0554 0.71739C17.3667 -0.17817 18.6333 -0.178173 18.9446 0.717387L22.4738 10.8706C22.6111 11.2656 22.9798 11.5335 23.398 11.542L34.1449 11.761C35.0928 11.7804 35.4842 12.9849 34.7286 13.5577L26.163 20.0517C25.8297 20.3044 25.6888 20.7378 25.81 21.1382L28.9226 31.4267C29.1972 32.3342 28.1725 33.0787 27.3943 32.5371L18.5712 26.3975C18.2279 26.1586 17.7721 26.1586 17.4288 26.3975L8.60571 32.5371C7.82746 33.0787 6.80281 32.3342 7.07737 31.4267L10.19 21.1382C10.3112 20.7378 10.1703 20.3044 9.83704 20.0517L1.27138 13.5577C0.515843 12.9849 0.907221 11.7804 1.85515 11.761L12.602 11.542C13.0202 11.5335 13.3889 11.2656 13.5262 10.8706L17.0554 0.71739Z",
    fill: "#FE9F11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledstar);
export default __webpack_public_path__ + "static/media/filledstar.b933e8a830aa2a52eec1229ac062bd75.svg";
export { ForwardRef as ReactComponent };